import React from "react";
import { Flex } from "rebass";

import { Scrollbar } from "../../Scrollbar";
import { EmptyList } from "./EmptyList";

interface IProps {
  activeName: string;
  isEmpty: boolean;
}

export const FileList: React.FC<IProps> = ({ children, isEmpty, activeName }) => (
  <Scrollbar>
    <Flex flexDirection="column">
      {
        isEmpty
          ? <EmptyList listName={activeName} />
          : children
      }
    </Flex>
  </Scrollbar>
);
